import React from 'react';
import { useBreakpoints } from 'common/hooks/use-breakpoints';
import { PriceBlock } from 'fronton-react';
import { pricesWrapper } from './styles';
import { ProductPriceToDisplayProps } from './types';
import { useProductPrice } from './use-product-price';

export const ProductPriceToDisplay: React.FC<ProductPriceToDisplayProps> = ({
  hasOldPrice,
  price,
  productPriceCategory,
}) => {
  const { mobile } = useBreakpoints() || { mobile: false };

  const { mainPrice, type, units, unitUnits, discount } = useProductPrice({
    hasOldPrice,
    price,
    productPriceCategory,
  });

  return (
    <div className={pricesWrapper}>
      <PriceBlock
        price={mainPrice}
        units={units}
        unitPrice={price.additional_price}
        unitUnits={unitUnits}
        discount={discount}
        oldPrice={price.previous_price ?? undefined}
        type={type}
        size={mobile ? 'm' : 'l'}
      />
    </div>
  );
};
